import { FiSettings } from 'react-icons/fi';
import { createIconComponent } from '../createIconComponent';

export const Cogwheel = createIconComponent(FiSettings);
